import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createLogger, Sentry } from "@/infrastructure/services/logger";
import { LoggerProvider } from "@/providers/LoggerProvider";
import App from "./App";
import "@/styles/globals.css";
import "@/styles/studio-ui-overrides.css";

createRoot(document.getElementById("root")!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    const logger = createLogger("main");
    logger.warn("Uncaught error:", error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <LoggerProvider>
      <App />
    </LoggerProvider>
  </StrictMode>,
);
